import { format } from 'date-fns';
import { Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IReadOnlyDatePillProps {
  date: Date;
}

export const ReadOnlyDatePill = ({ date }: IReadOnlyDatePillProps) => (
  <div
    data-testid="read-only-date-pill"
    data-cy="read-only-date-pill"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '8px 16px',
      borderRadius: 24,
      border: `1.5px solid ${Colors.secondary_500}`,
      backgroundColor: Colors.secondary_25,
    }}
  >
    <Text fontSize={16} color="neutral_400">
      {format(date, 'EEE, MMM dd, yyyy')}
    </Text>
  </div>
);
